// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusConfigurationCell-module__truncate--Q5p8c{max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"truncate": `StatusConfigurationCell-module__truncate--Q5p8c`
};
module.exports = ___CSS_LOADER_EXPORT___;
